export enum RegexpTypeEnum {
  MaxLength = 'maxLength',
}
